import * as React from "react";
import type { SVGProps } from "react";
const SvgStrategyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="strategy_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M298.667 85.333h426.666a213.333 213.333 0 0 1 213.334 213.334V512a213.333 213.333 0 0 1-213.334 213.333H298.667A213.333 213.333 0 0 1 85.333 512V298.667A213.333 213.333 0 0 1 298.667 85.333zm0 85.334a128 128 0 0 0-128 128V512a128 128 0 0 0 128 128h426.666a128 128 0 0 0 128-128V298.667a128 128 0 0 0-128-128H298.667zm246.528 128A42.667 42.667 0 0 1 587.86 256h137.472a42.667 42.667 0 0 1 30.166 72.832l-189.61 189.653a42.667 42.667 0 0 1-53.845 5.334l-71.168-47.446-118.528 79.019a42.667 42.667 0 1 1-47.36-70.997l142.293-94.806a42.667 42.667 0 0 1 47.36 0l65.707 43.819 91.946-92.075H587.82a42.667 42.667 0 0 1-42.667-42.666zM294.784 927.445a1536.085 1536.085 0 0 1 434.432 0l75.435 10.795a42.667 42.667 0 1 0 12.032-84.48l-75.392-10.795a1621.419 1621.419 0 0 0-458.582 0l-75.392 10.795a42.667 42.667 0 1 0 12.075 84.48l75.392-10.795z"
    />
  </svg>
);
export default SvgStrategyIcon;
